import { Text as RNText, type TextProps as RNTextProps } from 'react-native';

import { cn } from './cn';

export type TextVariant =
  | 'display' // big page headline — Archivo ExtraBold
  | 'title' // screen title — Archivo Bold
  | 'heading' // section / card heading
  | 'subtitle' // muted intro line under a title
  | 'body'
  | 'bodyMedium'
  | 'bodySemibold'
  | 'label' // form labels, strong inline
  | 'caption' // small muted text
  | 'accent' // uppercase field-manual markers ("TEMPLATES · 4")
  | 'accentSmall' // timestamps / initials
  | 'none'; // no base styling — caller supplies all classes

const VARIANTS: Record<TextVariant, string> = {
  none: '',
  display: 'font-display text-4xl leading-[1.05] text-foreground',
  title: 'font-heading text-[24px] leading-tight text-foreground',
  heading: 'font-heading text-xl leading-snug text-foreground',
  subtitle: 'font-sans text-base leading-relaxed text-muted',
  body: 'font-sans text-base leading-normal text-foreground',
  bodyMedium: 'font-sans-medium text-base leading-normal text-foreground',
  bodySemibold: 'font-sans-semibold text-base leading-normal text-foreground',
  label: 'font-sans-semibold text-sm text-foreground',
  caption: 'font-sans text-sm text-muted',
  accent: 'font-accent text-xs uppercase tracking-[0.12em] text-muted',
  accentSmall: 'font-accent text-[11px] text-muted',
};

export interface TextProps extends RNTextProps {
  variant?: TextVariant;
  className?: string;
}

export function Text({ variant = 'body', className, ...props }: TextProps) {
  return <RNText className={cn(VARIANTS[variant], className)} {...props} />;
}
